function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Legend"
}, React.createElement("text", {
  transform: "translate(613.641 300.7)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Bexar"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Dallas"), React.createElement("tspan", {
  x: 0,
  y: 31.2,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "El Paso"), React.createElement("tspan", {
  x: 0,
  y: 46.8,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Harris"), React.createElement("tspan", {
  x: 0,
  y: 62.4,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Tarrant"), React.createElement("tspan", {
  x: 0,
  y: 78,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Travis")), React.createElement("text", {
  transform: "translate(590.009 300.7)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "a"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "b"), React.createElement("tspan", {
  x: 0,
  y: 31.2,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "c"), React.createElement("tspan", {
  x: 0,
  y: 46.8,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "d"), React.createElement("tspan", {
  x: 0,
  y: 62.4,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "e"), React.createElement("tspan", {
  x: 0,
  y: 78,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "f")));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(88.141 378.752)"
}, "70"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(89.39 264.694)"
}, "75"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(87.505 144.872)"
}, "80"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(543.929 378.752)"
}, "70"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(543.929 264.695)"
}, "75"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(543.93 144.872)"
}, "80"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(543.929 31.831)"
}, "85"), React.createElement("text", {
  transform: "translate(37.52 33.761)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Group life"), React.createElement("tspan", {
  x: -12.1,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "expectancy")), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(114.44 12.592)"
}, "Black"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(263.88 12.592)"
}, "Hispanic"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(413.32 12.592)"
}, "White"), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.4 22.5H235v355.6H114.4z"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M263.9 22.5h120.6v355.6H263.9z"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M413.3 22.5h120.6v355.6H413.3z"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.4 200.3h120.7"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.4 81.8h120.7"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.4 259.6h120.7"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.4 141h120.7"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M263.9 318.8h120.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M263.9 200.3h120.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M263.9 81.8h120.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M263.9 259.6h120.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M263.9 141h120.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M413.3 318.8H534"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M413.3 200.3H534"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M413.3 81.8H534"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M413.3 259.6H534"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M413.3 141H534"
}), React.createElement("path", {
  stroke: "#ccc",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.32,
  d: "M114.4 318.8h120.7"
})), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(122.285 393.533)"
}, "a"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(141.173 393.533)"
}, "b"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(161.382 393.533)"
}, "c"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(180.094 393.533)"
}, "d"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(200.036 393.533)"
}, "e"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(221.22 393.533)"
}, "f"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(271.714 393.533)"
}, "a"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(290.602 393.533)"
}, "b"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(310.81 393.533)"
}, "c"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(329.523 393.533)"
}, "d"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(349.465 393.533)"
}, "e"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(370.649 393.533)"
}, "f"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(421.143 393.533)"
}, "a"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(440.031 393.533)"
}, "b"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(460.24 393.533)"
}, "c"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(478.952 393.533)"
}, "d"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(498.894 393.533)"
}, "e"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(520.078 393.533)"
}, "f"));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bars",
  fill: "#fff"
}, React.createElement("path", {
  d: "M119.3 237.8h13.6v140.8h-13.6z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M138.8 269.3h13.6v109.3h-13.6z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M158.2 144.9h13.6v233.7h-13.6z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M177.7 272.4h13.6v106.1h-13.6z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M197.1 229.1h13.6v149.5h-13.6z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M216.6 209.3h13.6v169.3h-13.6z",
  opacity: 0.4
}), React.createElement("path", {
  d: "M268.7 150.8h13.6v227.8h-13.6z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M288.2 39h13.6v339.6h-13.6z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M307.7 110.7h13.6v267.8h-13.6z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M327.1 46.4h13.6v332.2h-13.6z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M346.6 38.7h13.6v339.9h-13.6z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M366 61h13.6v317.6H366z",
  opacity: 0.4
}), React.createElement("path", {
  d: "M418.2 171.8h13.6v206.7h-13.6z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M437.6 173.6h13.6v205h-13.6z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M457.1 192.9h13.6v185.6h-13.6z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M476.6 168.1h13.6v210.5h-13.6z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M496 176.2h13.6v202.4H496z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M515.5 104.3h13.6v274.3h-13.6z",
  opacity: 0.4
}));

var SvgSDisparitiesDesktopColors = function SvgSDisparitiesDesktopColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Viz",
    x: 0,
    y: 0,
    viewBox: "0 0 800 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,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";
export { SvgSDisparitiesDesktopColors as ReactComponent };